import { Link } from "react-router-dom";

export const Home = () => {
    return (<>
        <Link to="/">Home</Link>

        <Link to="/users">Users</Link>
    </>);
}